//Apresentação.js
import React from 'react'
import { Text, View } from 'react-native'
import styles from './Styles.js'

const border = 1;

const Apresentação = () => {
  return (
    <View>
      <Text style={styles.titleText}>Apresentação</Text>
      <Text style={styles.baseText}>Marcio Adriano Seno é professor particular desde 1995, mora em Alphaville, Barueri SP Brasil.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>Tem lecionado para jovens de importantes famílias de empresários e executivos preparando seus estudantes para a vida universitária.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>Estudou na Universidade de São Paulo e se graduou em licenciatura de matemática na Universidade Metropolitana de Santos e em gestão empresarial na Faculdade de Tecnologia de São Paulo.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>Domina matemática, física e química entre todas as matérias do ensino fundamental e médio, além de estatística, cálculo e resistência dos materiais para ensino superior.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>Utiliza-se do método construtivista enfatizando que o estudante resolva problemas.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>É desenvolvedor hobista de React Native.</Text>
      <Text> </Text>
      <Text> </Text>
    </View>
  )
};
export default Apresentação;
